// extracted by mini-css-extract-plugin
module.exports = {"docsTitle":"SectionTitle_docsTitle__ZlFpE","linkIcon":"SectionTitle_linkIcon__dpUlA"};